import { useEffect, useRef } from 'react';

/**
 * A hook that runs a callback at a specified interval.
 * The interval can be dynamically changed or paused by passing null.
 * 
 * @param {Function} callback - The function to run at each interval
 * @param {number|null} delay - The interval delay in milliseconds, or null to pause
 */
export const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval
  useEffect(() => {
    const tick = () => {
      if (savedCallback.current) {
        savedCallback.current();
      }
    };

    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }

    // If delay is null, do nothing (no interval)
    return () => {};
  }, [delay]);
};